import axios from '../axios/axiosConfig';
import { getGeneralProjectTotalPages } from '../redux/api/generalProjectPagination';

const PAYLOCITY_TIMEOUT_MS = 45000;

export async function fetchPaylocityJobs(endpoint, jobs, signal) {
  const uniqueJobs = [...new Set(jobs)];
  if (!uniqueJobs.length || signal?.aborted) return { records: [], errors: {} };
  const records = await fetchPaylocityPages(endpoint, uniqueJobs.join(','), signal);
  return { records, errors: {} };
}

export async function fetchPaylocityPages(endpoint, jobs, signal) {
  const records = [];
  const limit = 1000;
  for (let page = 1; ; page += 1) {
    // These reads use axios directly; use its interceptor override rather than
    // changing portalApi's policy for unrelated requests.
    const { data: payload } = await axios.get(endpoint, {
      params: { jobs, page, limit }, signal, _requestTimeoutMs: PAYLOCITY_TIMEOUT_MS,
    });
    const rows = Array.isArray(payload) ? payload : payload?.data ?? payload?.Data ?? payload?.items ?? payload?.Items;
    if (!Array.isArray(rows) || rows.some(row => !row || typeof row !== 'object')) throw new Error('Unexpected Paylocity response: expected a list of time records.');
    records.push(...rows);
    const metadata = payload?.pagination ?? payload?.Pagination ?? payload;
    const hasPageCount = !Array.isArray(payload) && (metadata?.totalPages != null || metadata?.TotalPages != null || metadata?.totalRecords != null || metadata?.TotalRecords != null);
    if (hasPageCount ? page >= getGeneralProjectTotalPages({ limit, ...metadata }) : rows.length < limit) return records;
  }
}
